import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <section className="prose">
      <h1>No such page</h1>
      <p>
        That address does not exist. <Link to="/">Start from the beginning</Link>.
      </p>
    </section>
  )
}
